export enum PropertyUnitLogKey {
  PROPERTY_ADDED = 'property_added',
  FILE_ADDED = 'file_added',
  FILE_DELETED = 'file_deleted',
  PROPERTY_UPDATED_BY_ADMIN = 'property_updated_by_admin',
  PROPERTY_UPDATED_BY_CLIENT = 'property_updated_by_client',
  ORDER_STATUS_UPDATED = 'order_status_updated'
}
